import { Box } from "@chakra-ui/react";

import {
  colors,
  getCdnImageSrc,
  Image,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  Spacing,
  Spinner,
  VStack,
} from "goi_common";

import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  reviewContentState,
  reviewStarsState,
  additionalTagsState,
  priceTagsState,
  processTagsState,
  sincerityTagsState,
  reviewBadContentState,
} from "@/atoms/funeralReviewState";

import RecommendationTags from "./components/ReviewPost/RecommendationTags";
import ReviewDoneSection from "./components/ReviewPost/ReviewDoneSection";
import ReviewStarringSection from "./components/ReviewPost/ReviewStarringSection";
import ReviewTextareaSection from "./components/ReviewPost/ReviewTextareaSection";
import SmallButton from "goi_common/src/components/Buttons/SmallButton";
import { BottomSheet } from "./components/ReviewPost/BottomSheet";
import { funeralDirectorState } from "./remotes/atoms/funeralDirectorState";
import { postSangjoReview } from "@/apis/sangjoReview";
import MaxWidth1200Layout from "@/components/Layout/MaxWidth1200Layout";
import { isLoggedInState } from "@/atoms/accountState";

//상조 interface로 대체

function ReviewPostContainer({ id, name }: { id: string; name: string }) {
  const router = useRouter();
  const [currentStep, setCurrentStep] = useState("FDSELECT");
  const [good, setGood] = useRecoilState(reviewContentState);
  const [bad, setBad] = useRecoilState(reviewBadContentState);

  const [additional_charge, setAdd] = useRecoilState(additionalTagsState);
  const [price, setPrice] = useRecoilState(priceTagsState);
  const [process, setProcess] = useRecoilState(processTagsState);
  const [sincerity, setSincerity] = useRecoilState(sincerityTagsState);

  const [score, setScore] = useRecoilState(reviewStarsState);
  const isLoggedIn = useRecoilValue(isLoggedInState);

  const [fdSelectOpen, setFdSelectOpen] = useState(false);
  const [funeral_director, setFuneralDirector] = useRecoilState(funeralDirectorState);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      router.push(`/login?redirectTo=${encodeURIComponent(router.asPath)}`);
    }
  }, []);

  useEffect(() => {
    if (router.query.funeral_director) {
      setFuneralDirector(Number(router.query.funeral_director));
      setCurrentStep("POST");
    }
  }, [router.query]);

  const resetReview = () => {
    setGood("");
    setBad("");
    setAdd(-1);
    setPrice(-1);
    setProcess(-1);
    setSincerity(-1);
    setScore(0);
    setFuneralDirector(-1);
  };

  const postReview = async () => {
    if (isLoading) return;

    if (additional_charge == -1 || price == -1 || process == -1 || sincerity == -1) {
      alert("장례지도사님 서비스 평가를 각 1개 이상 골라주세요.");
      return;
    }

    if (good.length < 10) {
      alert("10자 이상의 좋았던 점을 남겨주세요.");
      return;
    }

    if (score == 0) {
      alert("별점을 1개 이상 남겨주세요");
      return;
    }

    setIsLoading(true);

    const response = await postSangjoReview({
      sangjo: Number(id),
      funeral_director,
      good,
      bad,
      process,
      sincerity,
      price,
      additional_charge,
      score,
    });
    if (response.status === 201) {
      setCurrentStep("DONE");
      setIsLoading(false);
    }
  };

  const doneReview = () => {
    router.push(`/review/`);
    resetReview();
  };

  return (
    <MaxWidth1200Layout>
      <Box>
        {currentStep == "FDSELECT" && (
          <>
            <Box padding="40px 24px">
              <h2 className="head2_sb">후기 작성</h2>
              <Spacing gap={28} />
              <div className="subtitle1_sb">동행한 장례지도사를 선택해주세요</div>
              <Spacing gap={16} />
              <div
                css={{
                  padding: "16px",
                  border: `1px solid ${colors.gray200}`,
                  borderRadius: "10px",
                }}
                className="body1 gray500"
                onClick={() => setFdSelectOpen(true)}
              >
                담당 장례지도사 선택하기
              </div>
              <BottomSheet
                id={id}
                open={fdSelectOpen}
                onClose={() => setFdSelectOpen(false)}
                setCurrentStep={setCurrentStep}
              />
            </Box>
          </>
        )}
        {currentStep == "POST" && (
          <>
            <Box padding="40px 24px">
              <h2 className="head2_sb">후기 작성</h2>
              <Spacing gap={28} />
              <Image
                alt={name}
                src={getCdnImageSrc(`platform/sangjos/${id}/logo-background.png`)}
                css={{ borderRadius: "16px" }}
                width={80}
              />
              <Box mt="24px" className="subtitle1_sb" textAlign="left">
                {name}는 어떠셨나요?
              </Box>
              <Box mt="12px" className="body2">
                온전히 고인을 추모하고 가족분들이 위로받으시는 데 충분한 도움을 드렸길 바랍니다.{" "}
                <br />
                상주님의 의견은 건강한 장례 시장과 문화를 만들어 나가는 데 큰 힘이 됩니다.
              </Box>
            </Box>
            <Box padding="40px 24px 32px 24px" backgroundColor={colors.warmGray50}>
              <Box className="subtitle1_sb">서비스를 평가해 주세요</Box>

              <RecommendationTags />
            </Box>
            <Box padding="40px 24px">
              <ReviewTextareaSection />
            </Box>

            <Box padding="0 24px 50px">
              <ReviewStarringSection name={name} />
            </Box>
          </>
        )}
        {currentStep === "DONE" && <ReviewDoneSection id={id} />}
        <VStack padding="0px 24px" alignItems="center">
          {currentStep === "POST" && (
            <LargeButton
              className="button"
              buttonType={LARGEL_BUTTON_TYPE.ORANGE}
              onClick={postReview}
            >
              {isLoading && <Spinner />} 후기 보내기
            </LargeButton>
          )}
          {currentStep === "DONE" && (
            <SmallButton type="orange" onClick={doneReview}>
              돌아가기
            </SmallButton>
          )}
        </VStack>
        <Spacing gap={20} />
      </Box>
    </MaxWidth1200Layout>
  );
}

export default ReviewPostContainer;
